import React from "react";
import{MdDateRange} from "react-icons/md"

import { MdCallMade } from "react-icons/md";

const RecentTCard = (props) => {
  const currntChain = localStorage.getItem('currentChain');
 
  const link = currntChain=== "bsc%20testnet"?"https://testnet.bscscan.com/tx/":"https://sepolia.etherscan.io/tx/";
  const fullhash = link+props.hash;
  
 
  return (
    <div className="py-2">
      <div className=" grid grid-cols-3  gap-4  p-3  items-center  rounded-md border border-gray-400 hover:shadow-md cursor-pointer    ">
     <div className=" md:flex items-center gap-12 pl-6">
     <MdDateRange size={34}/>
        <p className="text-sm md:tracking-widest md:text-base">{props.date}</p>
        
     </div>

        {/* <MdCallMade size={20} color="black" /> */}

        {/* <p className="text-xs   md:text-sm"></p> */}
       
        <div className="md:flex  items-center gap-6">
        
        <p className=" text-md  "> To Address</p>
        <p className="  text-xs text-slate-400 tracking-tighter overflow-hidden">
        
          { props.toAddress}
        </p>
        </div>
        {/* <p className=" ml-5 text-xs">
          $ <span className=" text-xs md:text-base font-bold">5.5</span>
        </p> */}
        <a href={fullhash} target="_blank" rel="noopener noreferrer" className="  tracking-widest text-green-400 overflow-hidden ">View Transaction</a>
        
      </div>
    </div>
  );
};

export default RecentTCard;
